import Icon from "./Icon";
import { cn } from "../../lib/utils";

/*
  کارت آماری: سه حالت رنگی شیشه‌ای + یک «کارت تاکیدی» لایمی
  (color="lime" همان کارت پررنگ شاخص قالب نمونه است)
*/
const COLOR_MAP = {
  green: "bg-emerald-500/12 text-emerald-600",
  lime: "bg-ink/10 text-ink",
  blue: "bg-indigo-500/12 text-indigo-600",
  amber: "bg-amber-500/14 text-amber-600",
  red: "bg-red-500/12 text-red-600",
};

export default function StatCard({
  title,
  value,
  subtitle,
  icon = "dashboard",
  color = "green",
}) {
  const accent = color === "lime";

  return (
    <div
      className={cn(
        "group relative overflow-hidden rounded-[1.75rem] p-5 transition-all duration-500 hover:-translate-y-1.5",
        accent
          ? "accent-card"
          : "glass hover:shadow-card-hover"
      )}
    >
      {!accent && (
        <div className="pointer-events-none absolute -left-10 -top-10 h-28 w-28 rounded-full bg-emerald-400/10 blur-2xl transition-transform duration-700 group-hover:scale-150" />
      )}

      <div className="relative flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p
            className={cn(
              "text-[13px] font-bold",
              accent ? "text-ink/70" : "text-slate-500"
            )}
          >
            {title}
          </p>

          <p
            className={cn(
              "mt-2 text-3xl font-black tracking-tight",
              accent ? "text-ink" : "text-ink"
            )}
          >
            {value}
          </p>
        </div>

        <span
          className={cn(
            "grid h-12 w-12 shrink-0 place-items-center rounded-2xl transition-transform duration-500 group-hover:rotate-6 group-hover:scale-110",
            COLOR_MAP[color] || COLOR_MAP.green
          )}
        >
          <Icon name={icon} className="h-5 w-5" />
        </span>
      </div>

      {subtitle && (
        <p
          className={cn(
            "relative mt-4 text-xs font-medium",
            accent ? "text-ink/60" : "text-slate-400"
          )}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
